import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CustomValidators } from 'src/app/shared/custom-validators';
import { BaseForm } from 'src/app/shared/product/baseForm';
import { GetCurrenciesService } from 'src/app/shared/product/components/currency/getCurrencies.service';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { LanguageService } from 'src/app/shared/services/language.service';
import { Validators } from 'src/app/shared/validators';

@Component({
  selector: 'app-quick-payment-step-one',
  templateUrl: './quick-payment-step-one.component.html',
  styleUrls: ['./quick-payment-step-one.component.scss']
})
export class QuickPaymentStepOneComponent extends BaseForm implements OnInit {

  formValidator;
  stepForm!: FormGroup;


  controllers = {
    Amount: {
      fieldName: "Amount",
      fieldNameAr: "المبلغ",
      fieldType: "product_image",
      isStaticUI: true,
      defaultValue: "",
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
        {
          validatorFn: Validators.min(1),
          message: `${this.validationMsg.min}1`,
          messageAr: `${this.validationMsgAr.min}الـ1`
        },
        {
          validatorFn: CustomValidators.requiredNumber,
          message: `${this.validationMsg.requiredNumber}`,
          messageAr: `${this.validationMsgAr.requiredNumber}`
        },
      ],
    },
    "Viewing Currency": {
      fieldName: "Viewing Currency",
      fieldNameAr: "اظهار العملة",
      fieldType: "no-label-select-list",
      fieldValues: [{ name: "EGP" }],
      defaultValue: "EGP",
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
      ],
    },
    Description: {
      fieldName: "Description",
      fieldNameAr: "الوصف",
      fieldType: "product_price",
      isStaticUI: true,
      defaultValue: "",
      validators: [

      ],
    },
    is_buyer_info:
    {

      'fieldName': 'Do you want to Add extra Buyer info fields to your product?',
      'fieldNameAr': 'هل تريد ان تأخذ معلومات اضافية من المشتري؟',
      'fieldType': 'Do you want to Add extra Buyer info fields to your product?',
      'isStaticUI': true,
      defaultValue: '',
      validators: []

    },
  };
  productTypeId: number;
  isUpdate: boolean;

  constructor(
    public translate: TranslateService,
    private getCurrencies : GetCurrenciesService,
    private languageService: LanguageService
  ) {
    super();
    this.formValidator = new FormValidatorService();
  }
  ngOnInit() {
    this.handleCurrencies()
    this.translate.use(localStorage.getItem("language"));
    this.languageService.languageUpdated.subscribe((lang: string) => {
      this.translate.use(lang);
    });
    this.stepForm = this.formValidator.createForm(
      Object.values(this.controllers)
    );

    this.fromControllers = this.stepForm;
    this.stepForm.markAsUntouched();
  }
  async handleCurrencies(){
    let currencies = await this.getCurrencies.make();
    this.controllers['Viewing Currency'].fieldValues = currencies.map(
      (currency: { id: number; name: string }) => {
        return { name: currency.name };
      }
    );
  }
  convertControls(name: string) {
    return this.stepForm.get(name) as FormControl;
  }
}
